import * as React from 'react'
import { Text, Stack, Colors } from '@doordash/design-language'
import Button from '@doordash/component-button'
import { SectionContainer } from './StyleComponents'
import { safetyCourse as t } from './strings'
import * as DA from '../../../typeModules/events'

const BUTTON_SUCCESS = 'SUCCESS'
const BUTTON_FAILURE = 'ERROR'

export const SubmitSection = ({
  track,
  completeCourse,
  onSubmit,
  courseId,
  buttonState,
}) => (
  <Stack size={Stack.Sizes.XLarge}>
    <SectionContainer>
      <Text styles={Text.Styles.Bold32}>
        {t.sections.courseConclusion.title()}
      </Text>
      <Stack>
        <Text styles={Text.Styles.SectionSubtext} color={Colors.TextSecondary}>
          {t.sections.courseConclusion.description()}
        </Text>
      </Stack>
      <Button
        type={Button.Types.PrimaryPill}
        size={Button.Sizes.Large}
        onClick={() => {
          track(
            DA.EventActions.Submit,
            DA.SafetyCourseSections.Course,
            courseId
          )
          completeCourse()
        }}
        state={buttonState}
        onAnimationEnd={status => {
          if (status === BUTTON_SUCCESS) {
            track(
              DA.EventActions.Success,
              DA.SafetyCourseSections.Course,
              courseId
            )
          } else if (status === BUTTON_FAILURE) {
            track(
              DA.EventActions.Error,
              DA.SafetyCourseSections.Course,
              courseId
            )
          }
          onSubmit()
        }}
      >
        {t.completeCourseButton()}
      </Button>
      <Text color={Text.Colors.TextSecondary} styles={Text.Styles.Medium12}>
        {t.completeCourseButtonDescription()}
      </Text>
    </SectionContainer>
  </Stack>
)
